const LOCAL_VISITS_PREFIX = 'analytics_total_visits_';
const LOCAL_TIME_PREFIX = 'analytics_total_time_seconds_';

export function getVisitStorageKey(userId: number | null): string {
  return `${LOCAL_VISITS_PREFIX}${userId ?? 'anonymous'}`;
}

export function getTotalTimeOnSiteSeconds(userId: number | null): number {
  try {
    const raw = localStorage.getItem(
      `${LOCAL_TIME_PREFIX}${userId ?? 'anonymous'}`,
    );
    return raw ? Math.max(0, parseFloat(raw)) : 0;
  } catch {
    return 0;
  }
}

export function addTotalTimeOnSiteSeconds(
  userId: number | null,
  seconds: number,
): void {
  if (seconds <= 0) return;
  try {
    const key = `${LOCAL_TIME_PREFIX}${userId ?? 'anonymous'}`;
    const current = getTotalTimeOnSiteSeconds(userId);
    localStorage.setItem(key, String(current + seconds));
  } catch {
    // intentionally empty
  }
}

export function getTotalVisits(userId: number | null): number {
  try {
    const raw = localStorage.getItem(getVisitStorageKey(userId));
    return raw ? Math.max(0, parseInt(raw, 10)) : 0;
  } catch {
    return 0;
  }
}

export function setTotalVisits(userId: number | null, count: number): void {
  try {
    localStorage.setItem(getVisitStorageKey(userId), String(count));
  } catch {
    // intentionally empty
  }
}

export function isUniqueUser(userId: number | null): boolean {
  return getTotalVisits(userId) === 0;
}
